'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import { getEventSelectorId } from '../../../../utils/analytics';
import { getFormattedUrl } from '../../../../utils/urls';
const I18N_PATH = 'appMarketplace.detail.overview.sidebar.resources';

const Link = props => /*#__PURE__*/_jsx(UILink, Object.assign({}, props, {
  external: true,
  iconProps: {
    className: 'hidden'
  }
}));

const Resources = ({
  casesUrl,
  forumUrl,
  onTrackInteraction,
  setupUrl,
  supportUrl
}) => {
  const trackInteraction = useCallback(action => onTrackInteraction(action, 'resources'), [onTrackInteraction]);
  return /*#__PURE__*/_jsxs(UIList, {
    children: [/*#__PURE__*/_jsxs(Link, {
      "data-hs-analytics-id": getEventSelectorId('SIDEBAR-SETUP-GUIDE'),
      href: getFormattedUrl(setupUrl),
      onClick: () => trackInteraction('click setup guide link'),
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "lesson"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_PATH}.setupGuideLinkText`
      })]
    }), supportUrl && /*#__PURE__*/_jsxs(Link, {
      "data-hs-analytics-id": getEventSelectorId('SIDEBAR-SUPPORT'),
      href: getFormattedUrl(supportUrl),
      onClick: () => trackInteraction('click support website link'),
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "website"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_PATH}.supportWebsiteLinkText`
      })]
    }), forumUrl && /*#__PURE__*/_jsxs(Link, {
      "data-hs-analytics-id": getEventSelectorId('SIDEBAR-COMMUNITY'),
      href: getFormattedUrl(forumUrl),
      onClick: () => trackInteraction('click community link'),
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "lists"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_PATH}.communityLinkText`
      })]
    }), casesUrl && /*#__PURE__*/_jsxs(Link, {
      href: getFormattedUrl(casesUrl),
      onClick: () => trackInteraction('click case study link'),
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "book"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_PATH}.caseStudyLinkText`
      })]
    })]
  });
};

Resources.propTypes = {
  casesUrl: PropTypes.string,
  forumUrl: PropTypes.string,
  onTrackInteraction: PropTypes.func.isRequired,
  setupUrl: PropTypes.string.isRequired,
  supportUrl: PropTypes.string
};
export default Resources;